import { render } from "./CalculatorSection.vue?vue&type=template&id=c36dcaee&scoped=true"
import script from "./CalculatorSection.vue?vue&type=script&lang=js"
export * from "./CalculatorSection.vue?vue&type=script&lang=js"

import "./CalculatorSection.vue?vue&type=style&index=0&id=c36dcaee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36dcaee"]])

export default __exports__